import { useMemo } from 'react';

import { TREATMENT_TYPE } from 'constants/patientList';
import { useTreatmentContext } from 'contexts/treatment.context';
import { PatientDetails } from 'types/PatientCard.types';
import { isBracesTemplatizedAlignerPrescription } from 'utils/bracesTemplatizedPrescription.utils';

/**
 * Braces templatized occlusion UI + payload rules: feature flag on and
 * treatment is BRACES. Referrals omit `type` on patient details, so when
 * `referralId` is set we treat the flow as BRACES (same as referral submit).
 */
export const useBracesTemplatizedOcclusionFields = (): boolean => {
  const { isBracesTemplatizedPrescriptionEnabled, patientDetails, referralId } =
    useTreatmentContext();

  return useMemo(
    () =>
      isBracesTemplatizedAlignerPrescription(
        isBracesTemplatizedPrescriptionEnabled,
        referralId
          ? TREATMENT_TYPE.BRACES
          : (patientDetails as PatientDetails | undefined)?.type
      ),
    [isBracesTemplatizedPrescriptionEnabled, patientDetails, referralId]
  );
};
